/**
 * @desc 导出运营调整详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/exportOperationAdjustment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
